// extracted by mini-css-extract-plugin
module.exports = {"root":"Discover_root__jhUTM","contentBx":"Discover_contentBx__lK20R","icon":"Discover_icon__rE2YM","articleExpertCard":"Discover_articleExpertCard__dN1ld"};